import React from 'react';
import Button from "@mui/material/Button";
import DisplayCard, {CARD_ASPECT_RATIO} from "../components/DisplayCard";
import ChoiceActionRow from "../components/ChoiceActionRow";

const GO_BACK_CLASS = "action.ActionGoBack";

export const SelectCards = ({state, userId, setConfirmAction}) => {

    const player = state.players[userId];
    const actions = state.actions[userId];
    // States such as SPONSOR or ANIMAL send the card selection alongside other
    // actions (a bonus to take instead, a go back...). The selection is the only
    // one carrying a list of cards; every other action is offered as a button
    // below the carousel, with go back last as elsewhere in the game.
    const action = actions.find(a => Array.isArray(a.cards));
    const otherActions = actions
        .filter(a => a !== action)
        .sort((a, b) => (a.class === GO_BACK_CLASS ? 1 : 0) - (b.class === GO_BACK_CLASS ? 1 : 0));
    const nbCards = action ? action.nbCards : 0;
    const canSelectLess = action ? action.canSelectLess : false;
    const canSelect = action  ? action.canSelect  :false;
    const [cards, setCards] = React.useState([]);
    const [notSelectedCards, setNotSelectedCards] = React.useState(action ? action.cards : []);

    // Having to pick exactly one card leaves nothing to confirm afterwards, so
    // that case drops the select buttons and the validate button and opens the
    // confirmation modal as soon as a card is clicked.
    const singleChoice = nbCards === 1 && !canSelectLess;

    const toggleCard = (card) => {
        if (cards.some(c => c.name === card.name)) {
            setCards(cards.filter(c => c.name !== card.name));
            setNotSelectedCards([...notSelectedCards, card]);
        } else {
            setCards([...cards, card]);
            setNotSelectedCards(notSelectedCards.filter(c => c.name !== card.name));
        }
    };

    const pickCard = (card, i) => {
        if (!canSelect[i]) return;
        if(!action) return;
        if (!singleChoice) {
            toggleCard(card);
            return;
        }
        setConfirmAction({
            action: {...action, cards: [card], notSelectedCards: action.cards.filter(c => c.name !== card.name)},
            message: action.confirmationMessage
        });
    };

    return <div>
        <h2>
            {action ? action.title : "C'est à vous de jouer"}
        </h2>
        {
            action && action.subtitle &&
            <h4>
                {action.subtitle}
            </h4>
        }
        <div>
            <div style={{
                width: '100%', overflow: 'auto',
                display: "inline-block",
                whiteSpace: "nowrap"
            }}>
                {
                    action && action.cards && action.cards.map((card, i) =>
                        <div
                            style={{
                                height: "80vh",
                                maxHeight: "450px",
                                margin: "20px 3vw",
                                display: "inline-block",
                                position: "relative",
                            }} key={card.name}>
                            <div
                                onClick={() => pickCard(card, i)}
                                style={{
                                    // without the select button underneath, the card takes the whole box
                                    width: "auto", height: singleChoice ? "100%" : "80%",
                                    aspectRatio: CARD_ASPECT_RATIO,
                                    // a card that cannot be picked is dimmed, and stops
                                    // looking clickable: with no select button underneath
                                    // there would be nothing else telling them apart
                                    opacity: canSelect[i] ? 1 : 0.5,
                                    cursor: canSelect[i] ? "pointer" : "default",
                                    filter: cards.some(c => c.name === card.name) ? 'drop-shadow(0 0 10px ' + (action.positive ? 'green' : 'red') + ')' : "none"
                                }}>
                                <DisplayCard card={card} adaptInfo={true} player={player}/>
                            </div>
                            {
                                cards.some(c => c.name === card.name) ?
                                    <img
                                        src={action.positive ? "/public/arknova/green_ok.png" : "/public/arknova/red_ko.png"}
                                        alt={"img " + card.name}
                                        onClick={() => pickCard(card, i)}
                                        style={{
                                            // top is explicit: the card is a block now, so the
                                            // static position of the badge would fall below it
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            zIndex: 12,
                                            position: "absolute",
                                            pointerEvents: "none"
                                        }}/> : undefined
                            }
                            {
                                !singleChoice &&
                                <div style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "10px"
                                }}>
                                    <Button
                                        variant={cards.some(c => c.name === card.name) ? "contained" : "outlined"}
                                        onClick={() => toggleCard(card)}
                                        disabled={!canSelect[i]}
                                        sx={{minWidth: '80px'}}
                                    >
                                        {cards.some(c => c.name === card.name) ? "Selected" : "Select"}
                                    </Button>
                                </div>
                            }
                        </div>
                    )
                }
            </div>
        </div>
        <div>
            {
                action && !singleChoice &&
                <React.Fragment>
                    {/*If not enough or too much cards selected to discard, display a message here*/}
                    <div>
                        {
                            !canSelectLess && cards.length < nbCards &&
                            <div style={{textAlign: "center"}}>
                                Veuillez
                                sélectionner {nbCards - cards.length} carte{nbCards - cards.length > 1 ? "s" : ""} supplémentaire{nbCards - notSelectedCards.filter(d => d).length > 1 ? "s" : ""}
                            </div>
                        }
                        {
                            cards.length > nbCards &&
                            <div style={{textAlign: "center"}}>
                                Veuillez désélectionner {cards.length - nbCards} carte{cards.length - nbCards > 1 ? "s" : ""}
                            </div>
                        }
                    </div>
                    <Button
                        variant={"contained"}
                        disabled={cards.length !== nbCards && !canSelectLess}
                        onClick={() => setConfirmAction({
                            action: {...action, notSelectedCards, cards},
                            message: action.confirmationMessage
                        })}
                        sx={{minWidth: '80px'}}
                    >
                        Valider
                    </Button>
                </React.Fragment>
            }
            {
                otherActions.length > 0 &&
                <div style={{marginTop: "16px"}}>
                    {
                        otherActions.map((a, i) =>
                            <ChoiceActionRow key={a.name + "" + i} action={a} setConfirmAction={setConfirmAction}/>
                        )
                    }
                </div>
            }
        </div>
    </div>


}
export default SelectCards;
